import React, { ComponentProps, ReactNode } from 'react'
import { EmptyPlaceholder } from '../EmptyPlaceholder/EmptyPlaceholder'
import { DATA_TABLE_NESTED_SEARCH_WIDTH, DataTableToolbar } from './toolbar'
import { DataTable, DataTableProps } from './DataTable'
import { NestedDataTableState } from './hooks/useNestedDataTableState'

const EMPTY_STATE_MIN_HEIGHT = 96

type NestedDataTableProps<TRow, TColumnId extends string> = Pick<
    DataTableProps<TRow, TColumnId>,
    'columns' | 'rows' | 'getRowId' | 'renderCell' | 'renderRowActions' | 'hiddenColumnIds' | 'pinnedSort'
> & {
    state: NestedDataTableState<TColumnId>
    toolbarProps: ComponentProps<typeof DataTableToolbar>
    searchPlaceholder: string
    emptyText: string
    notice?: ReactNode
}

export const NestedDataTable = <TRow, TColumnId extends string>({
    state,
    toolbarProps,
    searchPlaceholder,
    emptyText,
    notice,
    ...tableProps
}: NestedDataTableProps<TRow, TColumnId>) => (
    <>
        {notice}
        <DataTable
            {...tableProps}
            {...state}
            variant="nested"
            showIndexColumn
            hasStickyColumns
            toolbar={
                <DataTableToolbar
                    {...toolbarProps}
                    searchPlaceholder={searchPlaceholder}
                    searchWidth={DATA_TABLE_NESTED_SEARCH_WIDTH}
                />
            }
            emptyState={<EmptyPlaceholder text={emptyText} sx={{ minHeight: EMPTY_STATE_MIN_HEIGHT }} />}
        />
    </>
)

export default NestedDataTable
